<template>
  <div>
    <Card>
    <tables editable :columns="columns" v-model="tableData" :loading="tableLoading" />
      <Row class="page-con">
        <div class="page-bottom">
          <Page :current="page" :total="total" :page-size="pageSize" :page-size-opts="[10, 20, 30, 40, 100]" show-sizer
            show-elevator @on-change="changePage" @on-page-size-change="changePageSize" />
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import params from '../argu-page/params.vue'

import {search_keyword_list, delete_search_keyword} from "@/api/data";
import { getTimeDifference} from "@/api/uploadOss";

import Tables from "_c/tables/table-only.vue";
export default {
  components: { params , Tables},
  props: {
    resetFlag: {
      type: Boolean,
      default: false
    },
    editData: {
      type: Object,
      default: () => {}
    },
    edit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      page: 1,
      total: 0,
      pageSize: 10,
      classifyIds:[],
      loadding:false,
      video_show:false,
      tableLoading:false,
      show_path:'',
      videoSource:'',
      liveIds:[],
      tableData: [],
      columns: [
        {type: 'index', title: '序号',width: 100, align: "center"},
        { title: "关键字" , key: "keyword", align:'center', editable: true },
        { title: "分类" , key: "classify_name", align:'center', editable: true },
        { title: "平台" , key: "live_name", align:'center', editable: true },
        {
          title: "状态",
          key: "status",
          width: 100, align: "center",
          render: (h, params) => {
            var texts = "搜索完成"
           if (params.row.status == 0) {
              texts = "等待搜索"
            } else if (params.row.status == 1) {
              texts = "搜索中"
            }
            var color = '#515a6e'
            if (params.row.status == 2){
              color = '#03A9F4'
            }
            return h(
              "div",
              {
                props: {},
                style: {
                  color:color
                }
              },
              texts
            );
          },
        },
        { title: "创建时间", key: "create_time", editable: true, align: "center" ,render: (h, params) => {
            let texts = getTimeDifference(params.row.create_time)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }},
          { title: "更新时间", key: "update_time", editable: true, align: "center" ,render: (h, params) => {
            let texts = getTimeDifference(params.row.update_time)
            return h(
              "div",
              {
                props: {},
              },
              texts
            );
          }}
      ]

    }
  },
  watch: {

  },
  methods: {
    changePage(page) {
      this.page = page;
      this.handleSearch();
    },
    changePageSize(pageSize) {
      this.pageSize = pageSize;
      this.handleSearch();
    },
    setData() {
      let params = {
        page: this.page,
        pageSize: this.pageSize,
      }
      this.setTableLoading(true);
      search_keyword_list(params).then((res) => {
        if (res.data.code == 200) {
          this.tableData = res.data.data.records;
          this.total = res.data.data.total;
        } else {
          this.tableData = [];
          this.total = 0;
        }
        this.setTableLoading(false);
      });
    },
    setTableLoading(state) {
      this.tableLoading = state;
    },
    handleDelete(params) {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>是否确认删除？</p>',
        onOk: () => {
          delete_search_keyword(params.row.id)
            .then((res) => {
              if (res.data.code == 200) {
                this.handleSearch()
                this.$Message.success("成功!");
              } else {
                this.$Message.error(res.data.msg);
              }
            }).catch((err) => {
              this.$Message.error("失败!");
            });
        },
        onCancel: () => {
          this.$Message.info('已取消');
        }
      });
    },
    handleReset (name) {
    }
    
  }
}
</script>
